import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../components/layout/MainLayout";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import CaseManagementForm from "./CaseManagementForm";
import {
  fetchCaseManagement,
  updateCaseManagement,
  clearCurrentCaseManagement,
} from "../../store/slices/caseManagementSlice";

const EditCaseManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { currentCaseManagement, isLoading, error } = useSelector(
    (state) => state.caseManagements
  );

  const [formData, setFormData] = useState({
    patient_id: "",
    case_manager: "",
    call_type: "",
    interaction_type: "",
    calling_date: "",
    remarks: "",
    occupational_status: [],
    occupational_status_other: "",
    review_frequency: "",
    service_type: "",
    service_schedule_date: "",
    service_frequency: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(fetchCaseManagement(id));
    }
    return () => {
      dispatch(clearCurrentCaseManagement());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (currentCaseManagement && currentCaseManagement.id === parseInt(id)) {
      setFormData({
        patient_id: currentCaseManagement.patient_id || "",
        case_manager: currentCaseManagement.case_manager || "",
        call_type: currentCaseManagement.call_type || "",
        interaction_type: currentCaseManagement.interaction_type || "",
        calling_date: currentCaseManagement.calling_date || "",
        remarks: currentCaseManagement.remarks || "",
        occupational_status: currentCaseManagement.occupational_status || [],
        occupational_status_other: currentCaseManagement.occupational_status_other || "",
        review_frequency: currentCaseManagement.review_frequency || "",
        service_type: currentCaseManagement.service_type || "",
        service_schedule_date: currentCaseManagement.service_schedule_date || "",
        service_frequency: currentCaseManagement.service_frequency || "",
      });
    }
  }, [currentCaseManagement, id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    try {
      await dispatch(updateCaseManagement({ id, formData })).unwrap();

      Swal.fire({
        title: "Success!",
        text: "Case Management record updated successfully.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });

      navigate("/case-management");
    } catch (err) {
      if (typeof err === "object" && err !== null) {
        setErrors(err);
        Swal.fire({
          title: "Validation Error",
          text: "Please check the form for invalid inputs.",
          icon: "error",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: err || "Failed to update record.",
          icon: "error",
        });
      }
    }
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />
        <div className="card">
          <div className="card-header border-bottom">
            <h5 className="mb-0">Edit Case Management Record</h5>
          </div>
          <div className="card-body">
            {isLoading ? (
              <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <div className="alert alert-danger m-4">{error}</div>
            ) : (
              <form onSubmit={handleSubmit}>
                <CaseManagementForm
                  formData={formData}
                  setFormData={setFormData}
                  errors={errors}
                />
                <div className="row px-4 pb-4">
                  <div className="col-md-2 ms-auto">
                    <button type="submit" className="btn btn-primary w-100">
                      <i className="ri-save-3-line me-1"></i> Update
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default EditCaseManagement;
